import { ActionPermission, DynamicLoader, HorizontalAlignment, PermissionsUtil } from "@mcleod/core";
import { ImageName } from "@mcleod/images";
import { AbstractTableHeadingButton } from "../../AbstractTableHeadingButton";
import { ButtonVariant } from "../../../../button/ButtonVariant";
import { List, ListItemType } from "../../../../list/List";
import { LabelProps } from "../../../../label/LabelProps";
import { PinnedSearch } from "../../../PinnedSearch";
import { TableToolsConfigOptions } from "../../../TableToolsConfigOptions";
import { TableToolsExportOptions } from "../../../TableToolsExportOptions";
import { TableToolsAnalyticsOptions } from "../../../TableToolsAnalyticsOptions";

export class EllipsisActionsButton extends AbstractTableHeadingButton {
    override create() {
        super.create();
        this.button.setProps({
            id: `${this.table.id}-tools-buttonEllipsis`,
            enabled: true,
            variant: ButtonVariant.round,
            imageName: ImageName.menuEllipsis,
            tooltip: "Show more options",
            dropdownListProps: { maxHeight: 800 },
            dropdownItems: () => this.getEllipsisDropdownOptions()
        });
        return this.button;
    }

    private async getEllipsisDropdownOptions(): Promise<ListItemType[]> {
        const result: ListItemType[] = [];
        if (this.table.allowPin === true) {
            const pinnedSearch = new PinnedSearch(DynamicLoader.getRouteFromURL(), this.table.dataSource,
            this.commonDropdownProps);
            const pinnedSearchItem = await pinnedSearch.getDropdownItem();
            result.push(pinnedSearchItem);
        }
        if (this.table.allowConfig === true &&
            PermissionsUtil.isUserDeniedAction(ActionPermission.ACTION_OVERRIDE_GRID_CONFIGURATIONS) !== true) {
            this.addSeparator(result);
            const configOptions = new TableToolsConfigOptions(this.table, this.commonDropdownProps);
            const configItem = await configOptions.getConfigDropdownItem();
            result.push(configItem);
        }
        if (this.table.allowExport === true) {
            this.addSeparator(result);
            const exportItem = new TableToolsExportOptions(this.table, this.commonDropdownProps).getDropdownExportItem();
            result.push(exportItem);
        }
        // Add Analytics option
        this.addSeparator(result);
        const analyticsOptions = new TableToolsAnalyticsOptions(this.table, this.commonDropdownProps);
        const analyticsItem = await analyticsOptions.getDropdownAnalyticsItem();
        if(analyticsItem) {
            result.push(analyticsItem);
        }
        return result;
    }

    private addSeparator(array: ListItemType[]) {
        if (array.length > 0) {
            array.push(List.SEPARATOR);
        }
    }

    private get commonDropdownProps(): Partial<LabelProps> {
        return {
            borderWidth: 0,
            borderRadius: 0,
            marginTop: 0,
            marginBottom: 0,
            marginLeft: 0,
            minHeight: 34,
            align: HorizontalAlignment.LEFT,
            fontSize: "medium"
        };
    }
}
